import React from "react";
import { Layout, LevelDetails } from "../components";

const LevelDetailsPage = () => {
  return (
    <>
      <Layout>
        <LevelDetails />
      </Layout>
    </>
  );
};

export default LevelDetailsPage;
